import { isUpcomingAppointment } from '@avanta/shared/utils/appointments';
import { type AppointmentWithDetails } from 'types/appointments';

export const SESSION_STATUS = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  CANCELED: 'canceled',
  COMPLETED: 'completed',
} as const;

export type SessionStatus = (typeof SESSION_STATUS)[keyof typeof SESSION_STATUS];

/**
 * Session status matches the enterprise API view over flags + session lifecycle:
 * CANCELLED / DONE / CONFIRMED / PENDING — not a stored field.
 */
export const getSessionStatus = (
  appointment: Pick<
    AppointmentWithDetails,
    'confirmed' | 'canceled' | 'dateTime' | 'sessionDetails'
  >
): SessionStatus => {
  if (appointment.canceled) {
    return SESSION_STATUS.CANCELED;
  }

  if (!isUpcomingAppointment(appointment)) {
    return SESSION_STATUS.COMPLETED;
  }

  if (appointment.confirmed) {
    return SESSION_STATUS.CONFIRMED;
  }

  return SESSION_STATUS.PENDING;
};
